require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/core-js/library/fn/object/assign.js
// module id = 487
// module chunks = 2